<div class="keywords-container">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="keywords-division" *ngIf="hasData && adGroups?.length">
		<div class="adGroup">
			<h2 style="margin-bottom: 25px">Ad Groups</h2>
			<div
				class="adgroup-container primary-color-bg-on-hover-0-15"
				*ngFor="
					let adgroup of adGroups
						| paginate : { id: 'ad_group_pagination', itemsPerPage: 5, currentPage: currentPageNum };
					index as i;
					let l = count
				"
				[ngClass]="{ selectedAdgroup: selectedAdGroupIndex === adgroup.adGroupIndex }"
				(click)="updateKeywords(adgroup.adGroupIndex)"
			>
				<div class="font-14 primary-color adgroup-name" [title]="adgroup.name">{{ adgroup.name }}</div>
				<div class="metrics-division" [ngClass]="{ 'metrics-division-cutoff-date': isGoliveNotStarted }">
					<div class="metric-div" *ngFor="let legendObj of legend">
						<div *ngIf="legendObj.enabled">
							<div
								class="metric-label"
								appTooltip
								[attr.title]="legendObj.title"
								data-size="small"
								[options]="tooltipOptions"
							>
								{{ legendObj.displayName }}
							</div>
							<div *ngIf="adgroup[legendObj.value] !== null || adgroup[legendObj.value] !== undefined">
								<div class="metric-stat" *ngIf="!legendObj.isFloat">
									{{ adgroup[legendObj.value] | number }}
								</div>
								<div class="metric-stat" *ngIf="legendObj.isFloat">
									{{ adgroup[legendObj.value] | number : '.2-2' }}%
								</div>
							</div>
							<div *ngIf="adgroup[legendObj.value] === null || adgroup[legendObj.value] === undefined">
								<div class="metric-stat" *ngIf="!legendObj.isFloat">--</div>
								<div class="metric-stat" *ngIf="legendObj.isFloat">--%</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pagination">
				<pagination-template
					id="ad_group_pagination"
					#p="paginationApi"
					(pageChange)="currentPageNum = $event"
					*ngIf="adGroups.length > 5"
				>
					<ul class="pager">
						<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
							<a (click)="p.setCurrent(1)">
								<span>First</span>
							</a>
						</li>
						<li
							role="button"
							*ngFor="let page of p.pages"
							[class.current]="p.getCurrent() === page.value"
							class="pages"
							style="float: left"
						>
							<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
								{{ page.label }}
							</a>
							<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
								{{ page.label }}
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
							<a (click)="p.setCurrent(p.getLastPage())">
								<span>Last</span>
							</a>
						</li>
					</ul>
				</pagination-template>
			</div>
		</div>
		<div class="keywords-divider"></div>
		<div class="keywords">
			<h2>Keyword Performance</h2>
			<div class="keywords-datatable">
				<ngx-datatable
					class="{{ sectionclass }}ngx-datatable bootstrap material"
					[cssClasses]="cssClasses"
					[columnMode]="'flex'"
					[columns]="columns"
					[offset]="tableOffset"
					[sortType]="'single'"
					[limit]="datatableconfig.limit ? datatableconfig.limit : 20"
					[rowHeight]="datatableconfig.rowHeight ? datatableconfig.rowHeight : 50"
					[headerHeight]="datatableconfig.headerHeight ? datatableconfig.headerHeight : 50"
					[footerHeight]="datatableconfig.footerHeight ? datatableconfig.footerHeight : 50"
					[rows]="selectedAdGroupKeywords"
					[sorts]="defaultSort"
					(page)="onPageChange($event)"
				>
					<ng-template ngFor let-column [ngForOf]="columns">
						<ngx-datatable-column
							name="{{ column.name }}"
							prop="{{ column.prop }}"
							[resizeable]="false"
							[flexGrow]="column.flexGrow"
							[sortable]="true"
							[cellClass]="column.cellClass"
							[headerClass]="column.headerClass"
						>
							<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
								<span class="cursor-pointer">
									<span
										(click)="sort()"
										appTooltip
										[attr.title]="column.columnTooltip"
										data-size="small"
										[options]="tooltipOptions"
										[ngStyle]="{ float: colHeader.name === 'keyword' ? 'left' : 'right' }"
									>
										{{ colHeader.name }}
									</span>
								</span>
							</ng-template>
							<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
								<div class="column-value" *ngIf="column.prop == 'keyword'; else RegularBlock" [title]="row.keyword">
									<div class="keyword-name" [title]="row.keyword">{{ row.keyword }}</div>
								</div>
								<ng-template #RegularBlock>
									<div *ngIf="column.suffix; else RegularRowInnerTable">
										<div class="column-value">
											{{
												row[column.prop] > 0
													? row[column.prop] == '100' || row[column.prop] == '100.00'
														? 100
														: (row[column.prop] | number : '0.2-2')
													: '0.00'
											}}%
										</div>
									</div>

									<ng-template #RegularRowInnerTable>
										<span>{{ row[column.prop] | number }}</span>
									</ng-template>
								</ng-template>
							</ng-template>
						</ngx-datatable-column>
					</ng-template>
				</ngx-datatable>
			</div>
		</div>
	</div>
	<div class="keywords-division" *ngIf="!hasData">
		<div class="adGroup">
			<h2>Ad Groups</h2>
			<div
				class="adgroup-container primary-color-bg-on-hover-0-15"
				[ngClass]="{ selectedAdgroup: selectedAdGroupIndex === i }"
				(click)="updateKeywords(i)"
			>
				<div class="font-14 primary-color adgroup-name">--</div>
				<div class="metrics-division" [ngClass]="{ 'metrics-division-cutoff-date': isGoliveNotStarted }">
					<div class="metric-div" *ngFor="let legendObj of legend">
						<div *ngIf="legendObj.enabled">
							<div class="metric-label">
								{{ legendObj.displayName }}
							</div>
							<div class="metric-stat" *ngIf="!legendObj.isFloat">--</div>
							<div class="metric-stat" *ngIf="legendObj.isFloat">--%</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="keywords-divider"></div>
		<div class="keywords">
			<h2>Keyword Performance</h2>
			<div class="keywords-no-data">No Data Available</div>
		</div>
	</div>
</div>
